import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.css']
})
export class PageNotFoundComponent implements OnInit {
  constructor(public router: Router) {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/components/page-not-found/page-not-found.component.ts